/* eslint-disable import/prefer-default-export */
import { BASEAPI } from 'src/api/api';

const unwrap = (response) => response.data?.result;

const request = async (method, url, data, params, headers) => {
  try {
    const response = await BASEAPI({
      method, url, data, params, headers
    });
    return unwrap(response);
  } catch (error) {
    const raw = error?.response?.data?.error_message
      || error?.response?.data?.detail
      || error?.message
      || 'Unable to complete the request.';
    const message = typeof raw === 'string' ? raw : Object.values(raw || {}).flat().join(' ');
    const wrapped = new Error(message);
    wrapped.status = error?.response?.status;
    wrapped.fields = error?.response?.data?.error_message;
    throw wrapped;
  }
};

export const vehicleDetailsApi = {
  getOverview: (vehicleId, period = '30d') => request('GET', `vehicles/${vehicleId}/overview/`, null, { period }),
  getVehicle: (vehicleId) => request('GET', `vehicles/vehicle/${vehicleId}/`),
  updateVehicle: (vehicleId, data) => request('PATCH', `vehicles/vehicle/${vehicleId}/`, data),
  getServicePolicy: (vehicleId) => request('GET', `vehicles/${vehicleId}/service-policy/`),
  updateServicePolicy: (vehicleId, data) => request('PUT', `vehicles/${vehicleId}/service-policy/`, data),
  getServiceEvents: (vehicleId) => request('GET', `vehicles/${vehicleId}/service-events/`),
  recordService: (vehicleId, data, idempotencyKey) => request(
    'POST',
    `vehicles/${vehicleId}/service-events/`,
    data,
    null,
    { 'Idempotency-Key': idempotencyKey }
  ),
  supersedeService: (vehicleId, eventId, data, idempotencyKey) => request(
    'POST',
    `vehicles/${vehicleId}/service-events/${eventId}/supersede/`,
    data,
    null,
    { 'Idempotency-Key': idempotencyKey }
  ),
  getSites: () => request('GET', 'site-list/'),
  getGroups: () => request('GET', 'vehicle-group-list/'),
  getDepartments: () => request('GET', 'vehicle-department-list/'),
  getContractors: () => request('GET', 'vehicle-contractor-list/'),
  getTanks: () => request('GET', 'tank-list/'),
  createVehicle: (data) => request('POST', 'vehicles/vehicle/', data),
};
